import * as React from 'react';
import { CSSProperties } from 'react';

interface IProps {
    color: 'white' | 'red',
    onClick: () => void,
    style?: CSSProperties;
    containerStyle?: CSSProperties;
    big?: boolean;

}
export const ArrowDown = ({ color, onClick, style, big, containerStyle }: IProps) => {

    return <div className={`arrow-down-container ${big ? 'arrow-big' : ''}`} style={containerStyle} onClick={onClick}>
        <span style={style} className={color === 'white' ? "arrow-down white-arrow" : "arrow-down"} />
    </div>
}